import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';

import AuthorsList from '../AuthorsList';

export default function RelatedAuthors({ relatedAuthors, trackClick }) {
  if (relatedAuthors.size === 0) return null;

  return (
    <div className="cp-related-authors">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="related_authors" />
      </Heading>
      <AuthorsList authors={relatedAuthors} handleClick={linkText => trackClick(linkText)} />
    </div>
  );
}

RelatedAuthors.propTypes = {
  relatedAuthors: ImmutablePropTypes.list.isRequired,
  trackClick: PropTypes.func.isRequired
};
